import axios from 'axios';
import React, {useState} from 'react';
import password from '../assets/simboloContraseña.png';
import cuit from '../assets/simboloCuit.png';
import '../css/navBar.css';
import ojoAbierto from '../assets/ojoAbierto.svg';
import ojoCerrado from '../assets/ojoCerrado.svg';
import { handleError, toastError } from '../funciones.js';

function MainLogin(){
    const [contraseñaVisible, setContraseñaVisible] = useState(false);
    const [contraseñaVisibleMob, setContraseñaVisibleMob] = useState(false);

    function ingresar(){
        var contraseña, cuit, recordame;
        if(window.innerWidth > 575){
            contraseña = document.getElementById('inputPassword').value;
            cuit = document.getElementById('cuit').value;
            recordame = document.getElementById('flexCheckDefault');
        }
        else{   
            contraseña = document.getElementById('inputPasswordMobile').value;
            cuit = document.getElementById('cuitMobile').value;
            recordame = document.getElementById('flexCheckDefaultMobile');
        
        }
        if(cuit.localeCompare("") === 0){
            toastError("Cuit vacío, complete el campo de cuit")
        }
        else if(contraseña.localeCompare("") === 0){
            toastError("Contraseña vacía, complete el campo de contraseña")
        }
        else{
            
            const params = {  
                username: cuit,
                password: contraseña,
                recordarme: recordame.checked
            }

            axios
            .post(process.env.REACT_APP_URL + 'empresa/login', params)
            .then((res) => {
                localStorage.setItem(process.env.REACT_APP_TOKEN, res.data.jwt) 
                localStorage.setItem(process.env.REACT_APP_ID_EMPRESA, res.data.id) 
                localStorage.setItem(process.env.REACT_APP_NOMBRE_EMPRESA, res.data.username)
                localStorage.setItem(process.env.REACT_APP_MAIL_EMPRESA, res.data.email); 
                if(recordame.checked)
                   localStorage.setItem(process.env.REACT_APP_FECHA_CIERRE, -1)
                else
                    localStorage.setItem(process.env.REACT_APP_FECHA_REFRESH, Date.now() + 1500000)
                document.location.href ='/';
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
            
        }
    }

    function registrarse(){
        document.location.href ='/registrarse'; 
    }

    return(  
        <>  
            <div class="containerInicio d-block">
                <div class="modal-dialog modal-dialog-centered ">
                    <div class="modal-content rounded-4 ">
                    
                        <div class="modal-body p-0">
                            <div className='container px-5 py-5'>
                                <div className='row'>
                                <div className='col'>
                                    <h2 className='text-color-principal titulos mb-3 ocultarMobile'>Bienvenido/a</h2>   
                                </div>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                        <p className='d-none mostrarMobile textLoginMobile letraDatos pb-2 mb-0'>Cuit</p>
                                        <input id='cuit' class="form-control colorGrisLetra bold-botones bordesForms my-2 ocultarMobile" type="number" 
                                        placeholder="Cuit" aria-label="CUIT"/>
                                        <div className='rounded-4 me-5 mb-3 py-0 ps-1 centrarContainer botonBuscarCompleto bordesForms form-control w-100 mostrarLogin d-none'>
                                            <img className='mx-3 centrarCuitMobile' src={cuit} alt=""/>
                                            <input type="number" class="form-control p-0 my-0 bold-botones bg-transparent d-inline-block border-0 formLogin" id="cuitMobile" placeholder="Cuit"/>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                        <p className='d-none mostrarMobile textLoginMobile letraDatos mt-3 mb-0'>Contraseña</p>
                                        <div className='position-relative'>
                                        <input type={contraseñaVisible? 'text':'password'} class="form-control colorGrisLetra bold-botones bordesForms my-3 ocultarMobile contraseña" id="inputPassword" placeholder="Contraseña"/>
                                        
                                        <img id={'mostrarInputPassword'} className={'position-absolute imgMostrarContraseña cursor-pointer ocultarMobile'} onClick={()=>setContraseñaVisible(!contraseñaVisible)} 
                                        src={contraseñaVisible? ojoCerrado : ojoAbierto} />
                                        </div>
                                        <div className='position-relative rounded-4 me-5 mb-3 mt-2 py-0 ps-1 centrarContainer botonBuscarCompleto bordesForms form-control w-100 mostrarLogin d-none'>
                                            <img className='mx-3' src={password} alt=""/>
                                            <input type={contraseñaVisibleMob? 'text':'password'} class="form-control p-0 my-0 bold-botones bg-transparent d-inline-block border-0 formLogin contraseña" id="inputPasswordMobile" placeholder="Contraseña"/>
                                            
                                            <img id={'mostrarInputPasswordMobile'} className={'position-absolute imgMostrarContraseña cursor-pointer mobile-white'} onClick={()=>setContraseñaVisibleMob(!contraseñaVisibleMob)} 
                                            src={contraseñaVisibleMob? ojoCerrado : ojoAbierto} />
                                           
                                        </div>      
                                        
                                    </div>
                                </div>
                                <div className='row'>

                                    <div className='col-6  olvidoMobile cursor-pointer d-none ms-2 '>
                                        <div class="form-check">
                                            <input class="form-check-input bordesForms  cursor-pointer " type="checkbox" value="" id="flexCheckDefaultMobile"/>
                                            <label class="form-check-label bold-botones cursor-pointer " for="flexCheckDefaultMobile">
                                                Permanecer conectado
                                            </label>
                                        </div>
                                    </div>
                                    {/*<div className='col cursor-pointer olvidoMobile mb-4 ms-2 d-none ' data-bs-toggle="modal" data-bs-target="#modalCodigo">
                                            Olvidó su contraseña?
                                    </div>*/}{/**/}
                                    <div className='col cursor-pointer olvidoMobile mb-4 text-end me-2 d-none ps-0' data-bs-toggle="modal" data-bs-target="#modalCodigo">
                                            Olvidó su contraseña?
                                    </div>
                                </div>
                                
                                <div className='row align-items-center my-2'>
                                    <div className='col-7 ocultarMobile'>
                                        <div class="form-check">
                                            <input class="form-check-input bordesForms  cursor-pointer " type="checkbox" value="" id="flexCheckDefault"/>
                                            <label class="form-check-label bold-botones cursor-pointer " for="flexCheckDefault">
                                                Permanecer conectado
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col text-end'> 
                                        <button class="btn colorPrincipal text-white bold-botones" type="submit" onClick={ingresar}><div className='ocultarMobile'>Ingresar</div><div className='mostrarMobile d-none'>Iniciar Sesión</div></button>
                                    </div>
                                </div>
                                <div className='row my-3 ocultarMobile'>
                                    <div className='col text-center bold-botones cursor-pointer colorAzulHover ' data-bs-toggle="modal" data-bs-target="#modalCodigo">
                                        ¿Olvidó su contraseña?
                                    </div>
                                </div>

                                <div className='text-center mt-2'>
                                    <button class="btn btn-outline-primary bold-botones" type="submit" onClick={registrarse}>Nuevo Usuario</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


export default MainLogin;